
const custom = function() {
    const cardBlockLink = function(){
        const sourceLink = document.querySelectorAll('.card-block-link');
        sourceLink.forEach(element => {
            element.addEventListener('click', function(){
                window.location.href = this.dataset.link;
            })
        })
    }

    const headerMobileSearch = function(){
        document.addEventListener('click', function(e){
            const searchOverlay = document.querySelector('.header__icons .search-overlay')
            if(e.target == searchOverlay){
                document.querySelector('.mobile-view .header__icon-search').click();
            }
        })
    }

    const initContactForm = function(){
      const form = document.querySelector('#ContactForm');
      if (!form) {
        return;
      }

      form.addEventListener('submit', function(e){
        e.preventDefault();
        e.stopPropagation();

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData);
        const endpoint = 'https://api.shopcheck.huddled.com/public/shopify/contact';
        const store = 'https://kwiksales.com'; // window.location.origin;
        const fields = {};
        const messageContainerNode = form.querySelector('.js-message');

        if (!messageContainerNode) {
          return;
        }

        const messageNode = messageContainerNode.querySelector('span');

        messageNode.innerHTML = '';
        messageContainerNode.classList.add('visually-hidden');
        messageContainerNode.querySelector('.icon-error').classList.add('visually-hidden');
        messageContainerNode.querySelector('.icon-success').classList.add('visually-hidden');

        for (const [key, value] of Object.entries(data)) {
          if (key.startsWith('contact[')) {
            const fieldName = key.replace('contact[', '').replace(']', '');
            if (fieldName.toLowerCase() === 'consent') {
              continue;
            }

            fields[fieldName.toLowerCase()] = value;
          }
        }

        if (!fields.hasOwnProperty('email') || !fields.email || !fields.hasOwnProperty('message') || !fields.message) {
          messageNode.innerHTML = 'Please fill in all required fields.';
          messageContainerNode.classList.remove('visually-hidden');
          messageContainerNode.querySelector('.icon-error').classList.remove('visually-hidden');
          messageContainerNode.querySelector('.icon-success').classList.add('visually-hidden');
          return;
        }

        fields.site = 'Kwik Sales';

        const requestData = { store, fields };
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        };

        fetch(endpoint, requestOptions)
          .then(response => response.json())
          .then(() => {
            form.reset();
            e.target.classList.add('message-sent');
          })
          .catch(() => {
            messageNode.innerHTML = 'An error occurred while submitting the form. Please try again later.';
            messageContainerNode.classList.remove('visually-hidden');
            messageContainerNode.querySelector('.icon-error').classList.remove('visually-hidden');
            messageContainerNode.querySelector('.icon-success').classList.add('visually-hidden');
          });
      }, { capture: true });
    }

    return {
        init : function() {
            cardBlockLink();
            headerMobileSearch();
            initContactForm();
        }
    }
}();

document.addEventListener('DOMContentLoaded', ()=> {
    custom.init();
})


// Cookie helper functions
const CookieHelper = {
  get(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  },

  set(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
  }
};

// Age confirmation helper
const AgeConfirmation = {
  isConfirmed() {
    return CookieHelper.get('age_confirmed') === '1';
  },

  checkAndConfirm(container, onConfirm) {
    if (this.isConfirmed()) {
      container.classList.add('age-confirmed');
      if (onConfirm) onConfirm();
      return true;
    }

    if (container.classList.contains('age-confirmed')) {
      if (onConfirm) onConfirm();
      return true;
    }

    // Open the age confirmation modal
    const event = new CustomEvent('age-confirmation:open', {
      detail: {
        action: onConfirm
      }
    });
    document.dispatchEvent(event);

    return false;
  }
};

const ATCUiHandler = (function () {

  return {
    setQuantity,
    showQuantity,
    hideQuantity,
    showTrashOrMinus,
    handleMinMaxWording
  }

  function setQuantity(el, value) {
    el.querySelector('.quantity__input').value = value;
  }

  function showQuantity(el) {
    showTrashOrMinus(el);
    el.querySelector('.bb_qty-selector').classList.remove('bb-hidden');
    el.querySelector('.bb_atc-wrap').classList.add('bb-hidden');
  }

  function hideQuantity(el) {
    el.querySelector('.bb_qty-selector').classList.add('bb-hidden');
    el.querySelector('.bb_atc-wrap').classList.remove('bb-hidden');
  }

  function showTrashOrMinus(el) {
    const target = el.querySelector('.quantity__input');
    const elTrash = el.querySelector('.btn__trash');
    const elMinus = el.querySelector('.btn__minus');

    const qty = target.value;
    let min = parseInt(target.dataset.minAllowed);

    if (isNaN(min) || min == 0) {
      min = 1;
    }

    if (qty <= min) {
      elMinus.classList.add('bb-hidden');
      elTrash.classList.remove('bb-hidden');
    } else {
      elMinus.classList.remove('bb-hidden');
      elTrash.classList.add('bb-hidden');
    }
  }

  function handleMinMaxWording(target, qty) {
      const elMinMaxWording = target.closest('.bb_qty-atc').querySelector(".min-max-description");
      if (!elMinMaxWording) {
        return;
      }
      const minAllowed = parseInt(target.dataset.minAllowed);
      const maxAllowed = parseInt(target.dataset.maxAllowed);

      elMinMaxWording.classList.remove('bb-hidden');

      if (minAllowed && maxAllowed) {
        if (qty >= maxAllowed) {
          elMinMaxWording.innerHTML = `Max ${maxAllowed} per order`;
        } else {
          elMinMaxWording.innerHTML = `Min ${minAllowed} per order`;
        }

        return;
      }

      if (minAllowed) {
        elMinMaxWording.innerHTML = `Min ${minAllowed} per order`;
        return;
      }

      if (maxAllowed) {
        elMinMaxWording.innerHTML = `Max ${maxAllowed} per order`;
        return;
      }

        elMinMaxWording.innerHTML = `&nbsp;`;
        elMinMaxWording.classList.add('bb-hidden');

    }
}());

const ATCHandler = (function () {

  cartTimers = {};

  return {
    init,
    updateCartItem
  }

  ////////////////////////////////////////////////////////////////////////////

  function init() {
    registerPageEventHandlers();
    registerRebuyEventHandlers();
    enableCartIcon();
  }

  function registerPageEventHandlers() {
    _registerAtcClickHandler();
    _registerVariantChangeHandler();
    _registerQtyInputChangeHandler();
  }

  function enableCartIcon() {
    document.querySelector('.header__icon--cart').classList.remove('inactive');
  }

  function registerRebuyEventHandlers() {
    document.addEventListener('rebuy:cart.change', (event) => {
        // console.log("cart change", event.detail);
        updateCartSummary(event.detail);

        function updateCartSummary(cartDetails) {
          document.querySelectorAll('.cart-count-bubble .cart_item-count').forEach(ele =>{
              ele.innerHTML = cartDetails.cart.cart.item_count;
          })

          const headerCartContainer = document.querySelector('.l-cart-header');

          // Update the cart total price
          // get total price from cartDetails
          const m_total_el = document.querySelector('.m-total');
          const totalPrice = cartDetails.cart.cart.total_price;

          m_total_el.innerHTML = formatMoney(totalPrice);

          // Format money using Shopify's money formatter if available, otherwise use fallback
          function formatMoney(cents) {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              return Shopify.formatMoney(cents);
            }

            // Fallback formatting - convert cents to dollars with 2 decimal places
            return new Intl.NumberFormat('en-GB', {
              style: 'currency',
              currency: 'GBP'
            }).format(cents/100);
          }



          document.querySelectorAll('.cart_subtotal').forEach(ele =>{
            if (!window.hasOwnProperty('Rebuy') || !window.Rebuy.hasOwnProperty('SmartCart')) {
              return;
            }
            ele.innerHTML = Rebuy.SmartCart.formatMoney(cartDetails.cart.cart.total_price);
          })

          const rebuyCartItems = cartDetails.cart.cart.items;
          const combinedRebuyCartItems = _combineDuplicates(cartDetails.cart.cart.items);

          combinedRebuyCartItems.forEach(item => {
              const cardItems = document.querySelectorAll(`[name='id'][value='${item.variant_id}']`);
              cardItems.forEach(cardItem => {
                  if (item.quantity) {
                    ATCUiHandler.setQuantity(cardItem.closest('.bb_qty-atc'), item.quantity);
                    ATCUiHandler.showQuantity(cardItem.closest('.bb_qty-atc'));
                  }
              })
          })

          if (rebuyCartItems.length == 0) {
            const prodCards = document.querySelectorAll('.bb_qty-atc')
            prodCards.forEach(item => {
              ATCUiHandler.setQuantity(item, 0);
              ATCUiHandler.hideQuantity(item);
            })
            headerCartContainer.classList.add('is-empty-cart');
          } else {
            headerCartContainer.classList.remove('is-empty-cart');
          }
        }
    });

    document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
        const smartcart = event.detail.smartcart;
        const item = event.detail.item;

        const cardItems = document.querySelectorAll(`[name='id'][value='${item.variant_id}']`);
        cardItems.forEach(item => {
          ATCUiHandler.hideQuantity(item.closest('.bb_qty-atc'));
        })
    });
  }

  ////////////////////////////////////////////////////////////////////////////

  function _combineDuplicates(items) {
    return Object.values(
        items.reduce((acc, product) => {
            if (!acc[product.variant_id]) {
                acc[product.variant_id] = { ...product };
            } else {
                acc[product.variant_id].quantity += product.quantity;
            }
            return acc;
        }, {})
    );
  }

  /**
   * We need to take into account we can have multiple cart line items for same variant ID
   * This can happen if we run Buy X gt Y discounts
   */
  async function updateCartItem(updatesArray) {
    const responseFetch = await fetch('/cart.js');
    const cart = await responseFetch.json();

    let data = {};

    for (const [variantID, quantity] of Object.entries(updatesArray)) {
        let totalQuantity = 0;

        const matchingLineItems = cart.items.filter((item) => item.variant_id == variantID)
        if (matchingLineItems.length) {
          totalQuantity = matchingLineItems.reduce((acc, item) => acc + item.quantity, 0);
        }

        const deltaQuantity = quantity - totalQuantity;

        // get 1st line item for variant id
        const firstMatchingItem = cart.items.find(item => item.variant_id == variantID);
        const key = firstMatchingItem ? firstMatchingItem.key : null;

        const updateQuantity = firstMatchingItem.quantity + deltaQuantity;

        if (!key) {
          data[String(variantID)] = updateQuantity
        } else {
          data[String(key)] = updateQuantity
        }
    }

    const responseUpdate = await fetch('/cart/update.js',
      {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({updates: data})
      }
    );

    await responseUpdate.json();
  }

  function _registerAtcClickHandler() {
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.matches(".bb_qty-atc .bb_atc-wrap .bb_atc.one-option")) {
        return;
      }

      const target = e.target;
      e.preventDefault();

      const container = target.closest('.bb_qty-atc');
      const variantID = target.closest('form').querySelector('[name="id"]').value;

      const inputTarget = container.querySelector(".bb_qty-selector .quantity__input");
      const minAllowed = parseInt(inputTarget.dataset.minAllowed);
      let qty = 1;
      if (minAllowed) {
        qty = minAllowed;
      }

      ATCUiHandler.handleMinMaxWording(inputTarget, qty);

      // Check if this is an alcohol product
      if (container.classList.contains('alcohol')) {
        const proceedWithAddToCart = function() {
          container.classList.add('age-confirmed');

          let data = {
              "id" : variantID,
              "quantity" : qty
          }

          fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(data)
          })
          .then(response => {
              return response.json();
          })
          .then(data => {
            ATCUiHandler.setQuantity(container, 1);
            ATCUiHandler.showQuantity(container);
          })
          .catch((error) => {
              console.error('Error:', error);
          })
        };

        if (!AgeConfirmation.checkAndConfirm(container, proceedWithAddToCart)) {
          return;
        }
      }

      // Non-alcohol products or already confirmed
      let data = {
          "id" : variantID,
          "quantity" : qty
      }

      fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
      })
      .then(response => {
          return response.json();
      })
      .then(data => {
        ATCUiHandler.setQuantity(container, 1);
        ATCUiHandler.showQuantity(container);
      })
      .catch((error) => {
          console.error('Error:', error);
      })
    });
  }

  function _registerVariantChangeHandler() {
    document.addEventListener("variantChange", function (e) {

      const variantIdEls = document.querySelectorAll(`.product-atc-wrapper form[data-type='add-to-cart-form'] input[name='id']`);
      variantIdEls.forEach(el => {
        el.value = e.detail.id;
      });

      fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        }
      })
      .then(response => {
          return response.json();
      })
      .then(data => {
        const matchingLineItems = data.items.filter((item) => item.id == e.detail.id)
        if (matchingLineItems.length) {
          const totalQuantity = matchingLineItems.reduce((acc, item) => acc + item.quantity, 0);

          document.querySelectorAll('.product-atc-wrapper .bb_qty-atc').forEach(el => {
            ATCUiHandler.setQuantity(el, totalQuantity);
          });
          document.querySelectorAll('.product-atc-wrapper .bb_qty-atc').forEach(el => {
            ATCUiHandler.showQuantity(el);
          });
        } else {
          document.querySelectorAll('.product-atc-wrapper .bb_qty-atc').forEach(el => {
            ATCUiHandler.hideQuantity(el);
          });
        }

        document.querySelector('product-info .bb_qty-atc quantity-input').validateQtyRules(); // global.js QuantityInput custom element
      })
      .catch((error) => {
          console.error('Error:', error);
      })

    });
  }

  function _registerQtyInputChangeHandler() {
    document.addEventListener("change", function(e) {
      if (!e.target || !e.target.matches(".bb_qty-atc .bb_qty-selector .quantity__input")) {
        return;
      }

      const target = e.target;
      const prodId = target.closest('.bb_qty-atc').querySelector(".bb_atc-wrap [name='id']").value;

      if (cartTimers.hasOwnProperty(prodId)) {
        clearTimeout(cartTimers[prodId]);
      }

      let qty = parseInt(target.value);
      const minAllowed = parseInt(target.dataset.minAllowed);
      const maxAllowed = parseInt(target.dataset.maxAllowed);

      if (minAllowed && qty < minAllowed) {
        qty = 0;
      }

      e.preventDefault();


      ATCUiHandler.showTrashOrMinus(target.closest('.bb_qty-atc'));
      ATCUiHandler.handleMinMaxWording(target, qty);

      if (qty < 1) {
        const atc = target.closest('.bb_qty-atc');
        const variantId = atc.dataset.variantId;

        ATCUiHandler.hideQuantity(atc);

        const atcElement = atc.querySelector('.bb_atc-wrap');
        atcElement.classList.add('no-pointer-events');
        setTimeout(() => {
            atcElement.classList.remove('no-pointer-events');
        }, 500);

        const cardItems = document.querySelectorAll(`[name='id'][value='${variantId}']`);
        cardItems.forEach(item => {
          ATCUiHandler.hideQuantity(item.closest('.bb_qty-atc'));
        })
      }

      cartTimers[prodId] = setTimeout(() => {
        updateCartItem({ [prodId]: qty });
      }, 700);
    });
  }
})();

const MultiVariantHandler = (function () {

  return {
    init
  }

  ////////////////////////////////////////////////////////////////////////////

  function init() {
    _registerPageEventHandlers();
  }

  ////////////////////////////////////////////////////////////////////////////

  function _registerPageEventHandlers() {
    document.addEventListener("click", function(e) {
      if (!e.target || !e.target.matches(".bb_qty-atc .bb_atc-wrap .bb_atc.select-option")) {
        return;
      }

      const target = e.target;
      e.preventDefault();

      _onVariantSelect();
    });
  }

  function _onVariantSelect() {
      let timeoutId;

      function checkAndAppend() {
          document.querySelector('quick-add-modal.quick-add-modal[open]')?.classList.add('is-active');
          const prodActive = document.querySelector('quick-add-modal.quick-add-modal[open].is-active');

          if (prodActive) {
              clearTimeout(timeoutId);
          } else {
              timeoutId = setTimeout(checkAndAppend, 1000);
          }
      }

      timeoutId = setTimeout(checkAndAppend, 1000);
  }
})();

document.addEventListener('DOMContentLoaded', ()=>{
    ATCHandler.init();
    MultiVariantHandler.init();
})

document.querySelectorAll('a[href="#cookiebot"]').forEach(link => {
  link.addEventListener('click', function(event) {
      event.preventDefault();
      Cookiebot.renew();
  });
});


// Timer banner custom element implementation
class TimerBanner extends HTMLElement {
  constructor() {
    super();
    this.timerDisplay = this.querySelector('.timer-banner__time');
    this.endTime = null;
    this.interval = null;
    this.initialized = false;
  }

  connectedCallback() {
    if (this.timerDisplay) {
      const endTimeStr = this.timerDisplay.dataset.timer;
      if (endTimeStr) {
        this.endTime = new Date(endTimeStr).getTime();
        this.startTimer();
      }
    }
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startTimer() {
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endTime - now;

    if (distance <= 0) {
      clearInterval(this.interval);
      // Find and hide the entire timer banner element
      const timerBannerContainer = this.closest('.l-timer-banner');
      if (timerBannerContainer) {
        timerBannerContainer.style.visibility = 'hidden';
      }
      return;
    }

    // Calculate total hours (including days), minutes and seconds
    const totalDays = Math.floor(distance / (1000 * 60 * 60 * 24));
    const totalHours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Format with leading zeros
    const formatNumber = (num) => num.toString().padStart(2, '0');

    // Format as "XXh XXm XXs" with hardcoded prefix
    if (totalDays > 0) {
      this.timerDisplay.textContent = `${formatNumber(totalDays)}d ${formatNumber(totalHours)}h ${formatNumber(minutes)}m ${formatNumber(seconds)}s`;
    } else {
      this.timerDisplay.textContent = `${formatNumber(totalHours)}h ${formatNumber(minutes)}m ${formatNumber(seconds)}s`;
    }

    // After timer is calculated and active, make the container visible
    if (!this.initialized) {
      const timerBannerContainer = this.closest('.l-timer-banner');
      if (timerBannerContainer) {
        timerBannerContainer.style.visibility = 'visible';
      }
      this.initialized = true;
    }
  }
}

// Register the custom element
if (!customElements.get('timer-banner')) {
  customElements.define('timer-banner', TimerBanner);
}


class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('related-products-loaded', () => {
      setTimeout(() => {
        this.checkMinMaxDescription();
      }, 2000)
    })
  }

  connectedCallback() {
    this.checkMinMaxDescription();
  }

  checkMinMaxDescription() {
    try {
      const minMaxDescription = this.querySelector('.min-max-description');
      if (minMaxDescription) {
        const _featuredCollectionSwiper = this.querySelector('.custom-scroller_content.featured-collection_swiper');
        const recommendation_products_wrapperEl = this.querySelector('.recommendation-products_wrapper');

        if (_featuredCollectionSwiper) {
          _featuredCollectionSwiper.classList.add('has-min-max-description');
        }

        if (recommendation_products_wrapperEl) {
          recommendation_products_wrapperEl.classList.add('has-min-max-description');
          console.log('Added has-min-max-description class to recommendation-products_wrapper');
        }
      }
    } catch(e) {
      console.error('Error checking min-max description:', e);
    }
  }
}

if (!customElements.get('featured-collection')) {
  customElements.define('featured-collection', FeaturedCollection);
}

class CollectionGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkMinMaxDescription();
  }

  checkMinMaxDescription() {
    try {
      const minMaxDescription = this.querySelector('.min-max-description');
      if (minMaxDescription) {
        const _collectionGrid = this.querySelector('.product-grid.grid');

        if (_collectionGrid) {
          _collectionGrid.classList.add('has-min-max-description');
        }
      }
    } catch(e) {
      console.error('Error checking min-max description:', e);
    }
  }
}

if (!customElements.get('collection-grid')) {
  customElements.define('collection-grid', CollectionGrid);
}

class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.maxLength = 50; // Number of characters to show before "Read more"
    this.expanded = false;
    this.fullText = '';
    this.shortText = '';
    this.textContainer = null;
    this.readMoreLink = null;
    this.readLessLink = null;
  }

  connectedCallback() {
    this.textContainer = this.querySelector('.collection-description__text');
    if (!this.textContainer) return;

    this.fullText = this.textContainer.textContent.trim();

    if (this.fullText.length <= this.maxLength) {
      return;
    }

    this.shortText = this.fullText.slice(0, this.maxLength).trim() + '...';

    // Set initial truncated text
    this.textContainer.textContent = this.shortText;

    // Create the "Read more" link
    this.readMoreLink = document.createElement('a');
    this.readMoreLink.href = '#';
    this.readMoreLink.className = 'read-more-link';
    this.readMoreLink.textContent = 'Read more';
    this.readMoreLink.style.marginLeft = '4px';
    this.readMoreLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.showFullText();
    });

    // Create the "Read less" link
    this.readLessLink = document.createElement('a');
    this.readLessLink.href = '#';
    this.readLessLink.className = 'read-less-link';
    this.readLessLink.textContent = 'Read less';
    this.readLessLink.style.marginLeft = '4px';
    this.readLessLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.showShortText();
    });

    // Insert the "Read more" link after the text
    this.textContainer.classList.remove('initially-one-line');
    this.textContainer.appendChild(this.readMoreLink);
  }

  showFullText() {
    if (this.expanded) return;
    this.textContainer.textContent = this.fullText;
    this.textContainer.appendChild(this.readLessLink);
    this.expanded = true;
  }

  showShortText() {
    if (!this.expanded) return;
    this.textContainer.textContent = this.shortText;
    this.textContainer.appendChild(this.readMoreLink);
    this.expanded = false;
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}

class CarouselComponent extends HTMLElement {
  constructor() {
    super();

    if (this.getAttribute("slide-disable-mobile") && document.documentElement.clientWidth < 835) {
      return;
    }

    this.swiperInstance;
    this.thumbSwiperInstance;
    // Get Attributes attached to the component
    this.layoutType = this.getAttribute("slide-layout-type");
    this.slideSpeed = this.getAttribute("slide-speed");
    this.sliderPerView = this.getAttribute("slide-per-view");
    this.disableTouchMove = !this.hasAttribute("slide-disable-touch-move");
    this.keyboardDisable = !this.hasAttribute("slide-keyboard-disabled");
    // this.initialSlidePerVew = this.getAttribute("slide-initial-per-view")   || '1.3';
    // this.slideToMedia = this.getAttribute('slide-to-media');
    this.slidePaginationType =
      this.getAttribute("slide-pagination-type") || null;
    // this.mediaAutoPlay = this.hasAttribute('slide-media-autoplay');
    // this.responsive_breakpoints =
    //     JSON.parse(this.getAttribute('slide-responsive-breakpoints')) | {};
    this.responsive_breakpoints = JSON.parse(
      this.getAttribute("slide-responsive-breakpoints")
    );
    // Reference elements present inside component
    this.mainSliderElement = this.querySelector("[main-slider]");
    this.spaceBetween = this.getAttribute("space-between") || 20;
    this.thumbNailSliderElement = this.querySelector("[thumbnail-slider]");
    this.prevButton = this.querySelector("[slide-prev]");
    this.nextButton = this.querySelector("[slide-next]");
    this.slideProgressBar = this.querySelector("[slide-progress]");
    this.verticleThumbnail = this.getAttribute("verticle-thumbnail");
    this.sliderAutoplay = this.getAttribute("slide-autoplay") || "true";
    this.sliderAutoplayDelay = this.getAttribute("slide-autoplay-delay") || 5; // default 5 seconds
    this.sliderAnimation = this.getAttribute("slide-animation");
    this.slidePositionLeftIfLess = !this.hasAttribute("slide-no-center");
    this.sliderController = this.querySelector("[slider-controller]");
    this.customPagination = this.querySelector("[slide-pagination]");
    // query play/pause buttons if present
    this.playButton = this.querySelector('.swiper-button-play');
    this.pauseButton = this.querySelector('.swiper-button-pause');
    this.didCarouselInitiate = false;
    this.customNavigation =
      JSON.parse(this.getAttribute("slide-custom-nav-arrows")) || null;
    if (this.customNavigation) {
      let { nextArrow, prevArrow } = this.customNavigation;
      if (!nextArrow || !prevArrow)
        throw new Error(
          "Make sure to add next arrow and prevArrow key: values properly"
        );
      this.nextButton = this.querySelector(nextArrow);
      this.prevButton = this.querySelector(prevArrow);
    }
    this.loopSlide = this.hasAttribute("slide-loop");
    this.enableAfterInteraction = this.hasAttribute(
      "slide-enable-after-interaction"
    );
    this._animateOnSlideChange = this.hasAttribute("animate-on-slide-change");
    let options = {
      root: document,
      rootMargin: "0px",
      threshold: 0.01,
    };
    this.intersectionElement = this.hasAttribute("intersection-element");
    this.intersectionElement &&
      HELPER_UTIL.trigerElementFunctionalityInView(this, options);
  }

  //changes color of control on each slide change
  dynamic_navigation_color(swiperInstance) {
    const activeSlideElement =
      swiperInstance.slides[swiperInstance.activeIndex];
    let colorSchemeClass = activeSlideElement.getAttribute("data-color-scheme");
    this.sliderController.className = "";
    this.sliderController.classList.add(colorSchemeClass);
  }

  // Check for autoplay
  getSlideAutoplayParams() {
    if (this.sliderAutoplay == "true") {
      return {
        autoplay: {
          delay: parseInt(this.sliderAutoplayDelay) * 1000,
          pauseOnMouseEnter: true,
          disableOnInteraction: !this.enableAfterInteraction,
        },
      };
    }
    return {};
  }

  getSlideAnimationParams() {
    if (this.sliderAnimation === "fade") {
      return {
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      };
    }
    return {};
  }

  // Events for Swiper
  // Fired when swiper is initialize
  handleSliderAfterInitialization(swiperInstance) {
    this.classList.add("carousel-active");

    this.has_dynamic_navigation_color = this.hasAttribute(
      "dynamic-navigation-color"
    );
    if (this.has_dynamic_navigation_color && this.sliderController) {
      this.dynamic_navigation_color(swiperInstance);
    }
    setTimeout(() => {
      this.slideChangeAnimation(swiperInstance);
    }, 0);
  }

  // Run set of functions after slide change event is fired
  handleFunctionalityAfterSlideChange(swiperInstance) {
    this.autoPlayMediaOnActiveSlide(swiperInstance);

    if (this.has_dynamic_navigation_color && this.sliderController) {
      this.dynamic_navigation_color(swiperInstance);
    }

    this.slideChangeAnimation(swiperInstance);
  }

  autoPlayMediaOnActiveSlide(swiperInstance) {
    // Look for element which has video elements
    const activeSlideElement =
      swiperInstance.slides[swiperInstance.activeIndex];
    const mediaElement = activeSlideElement?.querySelector("[data-media-type]");
    if (mediaElement) {
      mediaElement.hasAttribute("media-autoplay") &&
        HELPER_UTIL.playMedia(mediaElement);
    }
  }

  // Run to animate elements on slide change
  slideChangeAnimation(swiperInstance) {
    if (!window.animation) return;
    const activeSlideElement =
      swiperInstance.slides[swiperInstance.activeIndex];
    if (this._animateOnSlideChange && activeSlideElement) {
      const animateElements =
        activeSlideElement.querySelectorAll("animation-reveal");
      animateElements &&
        animateElements.forEach((animateElement) => {
          animateElement.animateImageTxt(animateElement);
        });
    }
  }

  // Callable Methods for swiper
  // Method that initialize corousel for that component
  initSlider(sliderElement = this.mainSliderElement) {
    let sliderReponsiveData = this.responsive_breakpoints || {};
    if (this.thumbNailSliderElement) {
      this.initThumbnailSlider();
    }
    this.swiperInstance = new Swiper(sliderElement, {
      ally: true,
      lazy: true,
      speed: Number(this.slideSpeed) || 600,
      allowTouchMove: this.disableTouchMove,
      slidesPerView: this.sliderPerView,
      spaceBetween: Number(this.spaceBetween),
      preventClicksPropagation: false,
      centerInsufficientSlides: this.slidePositionLeftIfLess,
      threshold: 15,
      loop: this.loopSlide,
      // preventClicks: false,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      thumbs: {
        swiper: this.thumbSwiperInstance,
      },
      keyboard: {
        enabled: this.keyboardDisable,
      },
      pagination: {
        el: this.customPagination,
        clickable: true,
      },
      // Responsive breakpoints
      breakpoints: {
        ...sliderReponsiveData,
      },
      ...this.getSlideAutoplayParams(),
      ...this.getSlideAnimationParams(),
      // Listening to some slider events
      on: {
        init: this.handleSliderAfterInitialization.bind(this), // When swiper is initialized
        slideChange: this.handleFunctionalityAfterSlideChange.bind(this),
      },
    });


    // Play / Pause setup
    const swiper = this.swiperInstance;
    if (this.playButton && this.pauseButton) {
      // Click handlers
      this._playClickHandler = () => {
        // ensure autoplay params exist
        if (!swiper.params.autoplay || !swiper.params.autoplay.delay) {
          swiper.params.autoplay = {
            delay: (Number(this.sliderAutoplayDelay) || 5) * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }
        swiper.autoplay.start();
        this.playButton.style.display = 'none';
        this.pauseButton.style.display = 'inline-flex';
        this.playButton.setAttribute('aria-pressed','false');
        this.pauseButton.setAttribute('aria-pressed','true');
      };

      this._pauseClickHandler = () => {
        swiper.autoplay.stop();
        this.playButton.style.display = 'inline-flex';
        this.pauseButton.style.display = 'none';
        this.playButton.setAttribute('aria-pressed','true');
        this.pauseButton.setAttribute('aria-pressed','false');
      };

      this.playButton.addEventListener('click', this._playClickHandler);
      this.pauseButton.addEventListener('click', this._pauseClickHandler);

      // Reflect current autoplay state
      const isAutoplayRunning = !!(swiper.autoplay && swiper.autoplay.running);
      this.playButton.style.display = isAutoplayRunning ? 'none' : 'inline-flex';
      this.pauseButton.style.display = isAutoplayRunning ? 'inline-flex' : 'none';

      // Update buttons on autoplay events
      swiper.on('autoplayStart', () => {
        this.playButton.style.display = 'none';
        this.pauseButton.style.display = 'inline-flex';
      });
      swiper.on('autoplayStop', () => {
        this.playButton.style.display = 'inline-flex';
        this.pauseButton.style.display = 'none';
      });
    }




  }

  initThumbnailSlider() {
    this.thumbnailResponsiveBreakpoints = {
      992: {
        slidesPerView: this.verticleThumbnail == "true" ? "auto" : 4,
        direction: this.verticleThumbnail == "true" ? "vertical" : "horizontal",
      },
      767: {
        slidesPerView: 4.8,
        direction: "horizontal",
      },
    };
    if (this.hasAttribute("thumbnail-responsive-breakpoints")) {
      this.thumbnailResponsiveBreakpoints = JSON.parse(
        this.getAttribute("thumbnail-responsive-breakpoints")
      );
    }
    this.thumbSwiperInstance = new Swiper(this.thumbNailSliderElement, {
      ally: true,
      spaceBetween: Number(this.spaceBetween) || 20,
      slidesPerView: 3.8,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      centerInsufficientSlides: this.verticleThumbnail === "false",
      threshold: 15,
      keyboard: {
        enabled: true,
      },
      breakpoints: { ...this.thumbnailResponsiveBreakpoints },
    });
  }

  // Called when slider is connected to layout
  connectedCallback() {
    if (this.layoutType == "carousel") {
      if (this.intersectionElement) {
        this.addEventListener(_EVENT_HELPER.elementIsInCurrentView, () => {
          if (this.didCarouselInitiate) return;
          // If layout type is set to carouse then Show carousel

          this.initSlider();
          this.didCarouselInitiate = true;
        });
      } else {
        this.initSlider();
      }
    }
  }

  disconnectedCallback() {
    // Destroy Swiper instance if remove from page
    this.swiperInstance?.destroy();
    this.thumbSwiperInstance && this.thumbSwiperInstance?.destroy();
  }
}


customElements.define("carousel-component", CarouselComponent);
